export const TIMESHEET_TIMESHEET_ENTRIES_MANAGE_REQUESTED =
    'TIMESHEET_TIMESHEET_ENTRIES_MANAGE_REQUESTED';
export const TIMESHEET_TIMESHEET_ENTRIES_MANAGE_SUCCEEDED =
    'TIMESHEET_TIMESHEET_ENTRIES_MANAGE_SUCCEEDED';
export const TIMESHEET_TIMESHEET_ENTRIES_MANAGE_FAILED =
    'TIMESHEET_TIMESHEET_ENTRIES_MANAGE_FAILED';
export const TIMESHEET_TIMESHEET_ENTRIES_MANAGE_CANCELED =
    'TIMESHEET_TIMESHEET_ENTRIES_MANAGE_CANCELED';

export const TIMESHEET_TIMESHEET_ENTRIES_APPROVE_REQUESTED =
    'TIMESHEET_TIMESHEET_ENTRIES_APPROVE_REQUESTED';
export const TIMESHEET_TIMESHEET_ENTRIES_APPROVE_SUCCEEDED =
    'TIMESHEET_TIMESHEET_ENTRIES_APPROVE_SUCCEEDED';
export const TIMESHEET_TIMESHEET_ENTRIES_APPROVE_FAILED =
    'TIMESHEET_TIMESHEET_ENTRIES_APPROVE_FAILED';

export const TIMESHEET_TIMESHEET_ENTRIES_SET =
    'TIMESHEET_TIMESHEET_ENTRIES_SET';
export const TIMESHEET_TIMESHEET_ENTRIES_MERGE =
    'TIMESHEET_TIMESHEET_ENTRIES_MERGE';
export const TIMESHEET_TIMESHEET_ENTRIES_REMOVE =
    'TIMESHEET_TIMESHEET_ENTRIES_REMOVE';
export const TIMESHEET_TIMESHEET_ENTRY_SET = 'TIMESHEET_TIMESHEET_ENTRY_SET';
